var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestAddedSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "request-added-16px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d47500;\n      }\n\n      .st1 {\n        fill: #336;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M647.8,38H152.2c-62.2,0-112.7,50.4-112.7,112.7v360.5c0,62.2,50.4,112.7,112.7,112.7h22.5v112.7c0,9.1,5.5,17.3,13.9,20.8,2.7,1.1,5.7,1.7,8.6,1.7,6,0,11.7-2.4,16-6.6l128.6-128.6h306.1c62.2,0,112.7-50.4,112.7-112.7V150.7c0-62.2-50.4-112.7-112.7-112.7ZM715.4,511.2c0,37.3-30.3,67.6-67.6,67.6h-315.4c-6,0-11.7,2.4-16,6.6l-96.7,96.7v-80.8c0-12.4-10.1-22.5-22.5-22.5h-45.1c-37.3,0-67.6-30.3-67.6-67.6V150.7c0-37.3,30.3-67.6,67.6-67.6h495.7c37.3,0,67.6,30.3,67.6,67.6v360.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612,334c0,16.7-13.6,30.3-30.3,30.3h-151.4v151.4c0,16.7-13.6,30.3-30.3,30.3s-30.3-13.6-30.3-30.3v-151.4h-151.4c-16.7,0-30.3-13.6-30.3-30.3s13.6-30.3,30.3-30.3h151.4v-151.4c0-16.7,13.6-30.3,30.3-30.3s30.3,13.6,30.3,30.3v151.4h151.4c16.7,0,30.3,13.6,30.3,30.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAddedSvgrepoCom);
export default __webpack_public_path__ + "static/media/request-added-svgrepo-com.ff029b189baac38044fc64859383d39a.svg";
export { ForwardRef as ReactComponent };